<div [hidden]="!text" class="ag-tooltip ag-ltr ag-popup-child ag-popup-positioned-under" style="white-space: pre-wrap; width: max-content" [innerHTML]="text"></div>
